import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import Image from "gatsby-image"
import { RowContainer } from "./IndexUtils"

import ButtonLink from "../ButtonLink"

const OurPrograms = ({ textIcon, text = "*no text provided*", fluidImage }) => {
  // debugger
  const data = useStaticQuery(graphql`
    query {
      row3: file(relativePath: { eq: "helping.jpg" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 3840) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  const OurProgramsImage = fluidImage || data.row3.childImageSharp.fluid

  return (
    <article className="flex justify-center shadow-md rounded border border-gray-100">
      <RowContainer>
        <div className="leading-snug grid content-start grid-rows-containerContent">
          <h1 className="index__row3-content-title text-primary ">
            Our Programs
          </h1>
          <p className="text-secondary text-xl">{text}</p>
          <div className="flex justify-end">
            <ButtonLink
              handle="programs"
              text="Continue"
              className="text-2xl  "
            />
          </div>
        </div>
        <div className="relative grid align-middle">
          <div className="index__row-accentBox index__row-accentBox-right-offset hidden"></div>
          <Image
            fluid={{ ...OurProgramsImage, aspectRatio: 6 / 4 }}
            imgStyle={{ objectPosition: "top" }}
            style={{ borderRadius: "0.25rem" }}
          />
        </div>
      </RowContainer>
    </article>
  )
}

export default OurPrograms
